<template>
  <s-page class="max-w-2xl mx-auto" v-if="isDataLoaded">
    <resource-list />
  </s-page>
</template>

<script>
import SPage from '@/components/SPage'
import ResourceList from '@/components/ResourceList'
import { mapState } from 'vuex'

export default {
  name: 'Resources',
  components: {
    SPage,
    ResourceList
  },
  computed: {
    ...mapState('config', ['isDataLoaded'])
  }
}
</script>
